/**
 * Match referrer URL
 * @module
 */
var matchUrl = require('core/plugins/helpers/match_url');

exports.fieldsNeeded = ['referrer'];

exports.match = function(value, cond) {
  // Short circuit if there is no referrer
  if (value.referrer === null) {
    return false;
  }
  return matchUrl(value.referrer, cond);
};
